var le = (e, t, l) => new Promise((a, n) => {
  var o = (u) => {
    try {
      c(l.next(u));
    } catch (m) {
      n(m);
    }
  }, r = (u) => {
    try {
      c(l.throw(u));
    } catch (m) {
      n(m);
    }
  }, c = (u) => u.done ? a(u.value) : Promise.resolve(u.value).then(o, r);
  c((l = l.apply(e, t)).next());
});
import { registerMessageCompiler as Ht, registerMessageResolver as Yt, registerLocaleFallbacker as jt, setDevToolsHook as Bt, CORE_ERROR_CODES_EXTEND_POINT as Xt, DEFAULT_LOCALE as Qe, updateFallbackLocale as X, NUMBER_FORMAT_OPTIONS_KEYS as Jt, DATETIME_FORMAT_OPTIONS_KEYS as Kt, compile as zt, resolveValue as qt, fallbackWithLocaleChain as Ze, CORE_WARN_CODES_EXTEND_POINT as Qt, createCoreContext as Zt, clearDateTimeFormat as Pe, clearNumberFormat as Ae, isMessageAST as z, AST_NODE_PROPS_KEYS as en, setAdditionalMeta as tn, getFallbackContext as nn, NOT_REOSLVED as an, isTranslateFallbackWarn as ln, isTranslateMissingWarn as rn, parseTranslateArgs as Ce, translate as De, MISSING_RESOLVE_VALUE as Se, parseDateTimeArgs as ye, datetime as Ve, parseNumberArgs as Me, number as Ue, isMessageFunction as sn, setFallbackContext as We } from "../../../../@intlify_core-base@11.1.12/node_modules/@intlify/core-base/dist/core-base.js";
import { assign as D, isNumber as q, create as C, isString as g, isObject as R, isBoolean as N, warnOnce as et, makeSymbol as y, warn as se, isEmptyObject as on, getGlobalThis as K, format as cn, isArray as P, isPlainObject as O, isRegExp as oe, isFunction as $, inBrowser as ie, createEmitter as pe, deepCopy as re, hasOwn as ce } from "../../../../@intlify_shared@11.1.12/node_modules/@intlify/shared/dist/shared.js";
import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { setupDevtoolsPlugin as un } from "../../../../@vue_devtools-api@6.6.4/node_modules/@vue/devtools-api/lib/esm/index.js";
import { effectScope as _n, isRef as mn, ref as fn, shallowRef as dn } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { createCompileError as En } from "../../../../@intlify_message-compiler@11.1.12/node_modules/@intlify/message-compiler/dist/message-compiler.js";
import { defineComponent as Ie, h as tt, getCurrentInstance as Q, inject as gn, onMounted as bn, onUnmounted as vn, computed as J, watch as me, Fragment as nt, createVNode as pn, Text as In } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Nn = "11.1.12";
function Tn() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (K().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (K().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (K().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (K().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const b = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Xt,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function h(e, ...t) {
  return En(e, null, process.env.NODE_ENV !== "production" ? { messages: Ln, args: t } : void 0);
}
const Ln = {
  [b.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [b.INVALID_ARGUMENT]: "Invalid argument",
  [b.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [b.NOT_INSTALLED]: "Need to install with `app.use` function",
  [b.UNEXPECTED_ERROR]: "Unexpected error",
  [b.REQUIRED_VALUE]: "Required in value: {0}",
  [b.INVALID_VALUE]: "Invalid value",
  [b.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [b.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [b.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [b.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, fe = /* @__PURE__ */ y("__translateVNode"), de = /* @__PURE__ */ y("__datetimeParts"), Ee = /* @__PURE__ */ y("__numberParts"), w = /* @__PURE__ */ y("__enableEmitter"), Z = /* @__PURE__ */ y("__disableEmitter"), at = y("__setPluralRules"), lt = /* @__PURE__ */ y("__injectWithOption"), ge = /* @__PURE__ */ y("__dispose"), A = {
  FALLBACK_TO_ROOT: Qt,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, On = {
  [A.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [A.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [A.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [A.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [A.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [A.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function G(e, ...t) {
  return cn(On[e], ...t);
}
function ee(e) {
  if (!R(e) || z(e))
    return e;
  for (const t in e)
    if (ce(e, t))
      if (!t.includes("."))
        R(e[t]) && ee(e[t]);
      else {
        const l = t.split("."), a = l.length - 1;
        let n = e, o = !1;
        for (let r = 0; r < a; r++) {
          if (l[r] === "__proto__")
            throw new Error(`unsafe key: ${l[r]}`);
          if (l[r] in n || (n[l[r]] = C()), !R(n[l[r]])) {
            process.env.NODE_ENV !== "production" && se(G(A.IGNORE_OBJ_FLATTEN, {
              key: l[r]
            })), o = !0;
            break;
          }
          n = n[l[r]];
        }
        if (o || (z(n) ? en.includes(l[a]) || delete e[t] : (n[l[a]] = e[t], delete e[t])), !z(n)) {
          const r = n[l[a]];
          R(r) && ee(r);
        }
      }
  return e;
}
function Ne(e, t) {
  const { messages: l, __i18n: a, messageResolver: n, flatJson: o } = t, r = O(l) ? l : P(a) ? C() : { [e]: C() };
  if (P(a) && a.forEach((c) => {
    if ("locale" in c && "resource" in c) {
      const { locale: u, resource: m } = c;
      u ? (r[u] = r[u] || C(), re(m, r[u])) : re(m, r);
    } else
      g(c) && re(JSON.parse(c), r);
  }), n == null && o)
    for (const c in r)
      ce(r, c) && ee(r[c]);
  return r;
}
function rt(e) {
  return e.type;
}
function st(e, t, l) {
  let a = R(t.messages) ? t.messages : C();
  "__i18nGlobal" in l && (a = Ne(e.locale.value, {
    messages: a,
    __i18n: l.__i18nGlobal
  }));
  const n = Object.keys(a);
  n.length && n.forEach((o) => {
    e.mergeLocaleMessage(o, a[o]);
  });
  {
    if (R(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((r) => {
        e.mergeDateTimeFormat(r, t.datetimeFormats[r]);
      });
    }
    if (R(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((r) => {
        e.mergeNumberFormat(r, t.numberFormats[r]);
      });
    }
  }
}
function $e(e) {
  return pn(In, null, e, 0);
}
const we = "__INTLIFY_META__", xe = () => [], hn = () => !1;
let Ge = 0;
function He(e) {
  return (t, l, a, n) => e(l, a, Q() || void 0, n);
}
const Fn = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Q();
  let t = null;
  return e && (t = rt(e)[we]) ? { [we]: t } : null;
};
function Te(e = {}) {
  const { __root: t, __injectWithOption: l } = e, a = t === void 0, n = e.flatJson, o = ie ? fn : dn;
  let r = N(e.inheritLocale) ? e.inheritLocale : !0;
  const c = o(
    // prettier-ignore
    t && r ? t.locale.value : g(e.locale) ? e.locale : Qe
  ), u = o(
    // prettier-ignore
    t && r ? t.fallbackLocale.value : g(e.fallbackLocale) || P(e.fallbackLocale) || O(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : c.value
  ), m = o(Ne(c.value, e)), E = o(O(e.datetimeFormats) ? e.datetimeFormats : { [c.value]: {} }), L = o(O(e.numberFormats) ? e.numberFormats : { [c.value]: {} });
  let f = t ? t.missingWarn : N(e.missingWarn) || oe(e.missingWarn) ? e.missingWarn : !0, p = t ? t.fallbackWarn : N(e.fallbackWarn) || oe(e.fallbackWarn) ? e.fallbackWarn : !0, T = t ? t.fallbackRoot : N(e.fallbackRoot) ? e.fallbackRoot : !0, k = !!e.fallbackFormat, V = $(e.missing) ? e.missing : null, S = $(e.missing) ? He(e.missing) : null, F = $(e.postTranslation) ? e.postTranslation : null, H = t ? t.warnHtmlMessage : N(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, Y = !!e.escapeParameter;
  const j = t ? t.modifiers : O(e.modifiers) ? e.modifiers : {};
  let B = e.pluralRules || t && t.pluralRules, _;
  _ = (() => {
    a && We(null);
    const s = {
      version: Nn,
      locale: c.value,
      fallbackLocale: u.value,
      messages: m.value,
      modifiers: j,
      pluralRules: B,
      missing: S === null ? void 0 : S,
      missingWarn: f,
      fallbackWarn: p,
      fallbackFormat: k,
      unresolving: !0,
      postTranslation: F === null ? void 0 : F,
      warnHtmlMessage: H,
      escapeParameter: Y,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    s.datetimeFormats = E.value, s.numberFormats = L.value, s.__datetimeFormatters = O(_) ? _.__datetimeFormatters : void 0, s.__numberFormatters = O(_) ? _.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (s.__v_emitter = O(_) ? _.__v_emitter : void 0);
    const i = Zt(s);
    return a && We(i), i;
  })(), X(_, c.value, u.value);
  function ue() {
    return [
      c.value,
      u.value,
      m.value,
      E.value,
      L.value
    ];
  }
  const mt = J({
    get: () => c.value,
    set: (s) => {
      _.locale = s, c.value = s;
    }
  }), ft = J({
    get: () => u.value,
    set: (s) => {
      _.fallbackLocale = s, u.value = s, X(_, c.value, s);
    }
  }), dt = J(() => m.value), Et = /* @__PURE__ */ J(() => E.value), gt = /* @__PURE__ */ J(() => L.value);
  function bt() {
    return $(F) ? F : null;
  }
  function vt(s) {
    F = s, _.postTranslation = s;
  }
  function pt() {
    return V;
  }
  function It(s) {
    s !== null && (S = He(s)), V = s, _.missing = S;
  }
  function Nt(s, i) {
    return s !== "translate" || !i.resolvedMessage;
  }
  const M = (s, i, d, v, U, ae) => {
    ue();
    let x;
    try {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && tn(/* @__PURE__ */ Fn()), a || (_.fallbackContext = t ? nn() : void 0), x = s(_);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (_.fallbackContext = void 0);
    }
    if (d !== "translate exists" && // for not `te` (e.g `t`)
    q(x) && x === an || d === "translate exists" && !x) {
      const [W, Gt] = i();
      if (process.env.NODE_ENV !== "production" && t && g(W) && Nt(d, Gt) && (T && (ln(p, W) || rn(f, W)) && se(G(A.FALLBACK_TO_ROOT, {
        key: W,
        type: d
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ke } = _;
        ke && T && ke.emit("fallback", {
          type: d,
          key: W,
          to: "global",
          groupId: `${d}:${W}`
        });
      }
      return t && T ? v(t) : U(W);
    } else {
      if (ae(x))
        return x;
      throw h(b.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Fe(...s) {
    return M((i) => Reflect.apply(De, null, [i, ...s]), () => Ce(...s), "translate", (i) => Reflect.apply(i.t, i, [...s]), (i) => i, (i) => g(i));
  }
  function Tt(...s) {
    const [i, d, v] = s;
    if (v && !R(v))
      throw h(b.INVALID_ARGUMENT);
    return Fe(i, d, D({ resolvedMessage: !0 }, v || {}));
  }
  function Lt(...s) {
    return M((i) => Reflect.apply(Ve, null, [i, ...s]), () => ye(...s), "datetime format", (i) => Reflect.apply(i.d, i, [...s]), () => Se, (i) => g(i) || P(i));
  }
  function Ot(...s) {
    return M((i) => Reflect.apply(Ue, null, [i, ...s]), () => Me(...s), "number format", (i) => Reflect.apply(i.n, i, [...s]), () => Se, (i) => g(i) || P(i));
  }
  function ht(s) {
    return s.map((i) => g(i) || q(i) || N(i) ? $e(String(i)) : i);
  }
  const Ft = {
    normalize: ht,
    interpolate: (s) => s,
    type: "vnode"
  };
  function Rt(...s) {
    return M((i) => {
      let d;
      const v = i;
      try {
        v.processor = Ft, d = Reflect.apply(De, null, [v, ...s]);
      } finally {
        v.processor = null;
      }
      return d;
    }, () => Ce(...s), "translate", (i) => i[fe](...s), (i) => [$e(i)], (i) => P(i));
  }
  function kt(...s) {
    return M((i) => Reflect.apply(Ue, null, [i, ...s]), () => Me(...s), "number format", (i) => i[Ee](...s), xe, (i) => g(i) || P(i));
  }
  function Pt(...s) {
    return M((i) => Reflect.apply(Ve, null, [i, ...s]), () => ye(...s), "datetime format", (i) => i[de](...s), xe, (i) => g(i) || P(i));
  }
  function At(s) {
    B = s, _.pluralRules = B;
  }
  function Ct(s, i) {
    return M(() => {
      if (!s)
        return !1;
      const d = g(i) ? i : c.value, v = Re(d), U = _.messageResolver(v, s);
      return z(U) || sn(U) || g(U);
    }, () => [s], "translate exists", (d) => Reflect.apply(d.te, d, [s, i]), hn, (d) => N(d));
  }
  function Dt(s) {
    let i = null;
    const d = Ze(_, u.value, c.value);
    for (let v = 0; v < d.length; v++) {
      const U = m.value[d[v]] || {}, ae = _.messageResolver(U, s);
      if (ae != null) {
        i = ae;
        break;
      }
    }
    return i;
  }
  function St(s) {
    const i = Dt(s);
    return i != null ? i : t ? t.tm(s) || {} : {};
  }
  function Re(s) {
    return m.value[s] || {};
  }
  function yt(s, i) {
    if (n) {
      const d = { [s]: i };
      for (const v in d)
        ce(d, v) && ee(d[v]);
      i = d[s];
    }
    m.value[s] = i, _.messages = m.value;
  }
  function Vt(s, i) {
    m.value[s] = m.value[s] || {};
    const d = { [s]: i };
    if (n)
      for (const v in d)
        ce(d, v) && ee(d[v]);
    i = d[s], re(i, m.value[s]), _.messages = m.value;
  }
  function Mt(s) {
    return E.value[s] || {};
  }
  function Ut(s, i) {
    E.value[s] = i, _.datetimeFormats = E.value, Pe(_, s, i);
  }
  function Wt(s, i) {
    E.value[s] = D(E.value[s] || {}, i), _.datetimeFormats = E.value, Pe(_, s, i);
  }
  function $t(s) {
    return L.value[s] || {};
  }
  function wt(s, i) {
    L.value[s] = i, _.numberFormats = L.value, Ae(_, s, i);
  }
  function xt(s, i) {
    L.value[s] = D(L.value[s] || {}, i), _.numberFormats = L.value, Ae(_, s, i);
  }
  Ge++, t && ie && (me(t.locale, (s) => {
    r && (c.value = s, _.locale = s, X(_, c.value, u.value));
  }), me(t.fallbackLocale, (s) => {
    r && (u.value = s, _.fallbackLocale = s, X(_, c.value, u.value));
  }));
  const I = {
    id: Ge,
    locale: mt,
    fallbackLocale: ft,
    get inheritLocale() {
      return r;
    },
    set inheritLocale(s) {
      r = s, s && t && (c.value = t.locale.value, u.value = t.fallbackLocale.value, X(_, c.value, u.value));
    },
    get availableLocales() {
      return Object.keys(m.value).sort();
    },
    messages: dt,
    get modifiers() {
      return j;
    },
    get pluralRules() {
      return B || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(s) {
      f = s, _.missingWarn = f;
    },
    get fallbackWarn() {
      return p;
    },
    set fallbackWarn(s) {
      p = s, _.fallbackWarn = p;
    },
    get fallbackRoot() {
      return T;
    },
    set fallbackRoot(s) {
      T = s;
    },
    get fallbackFormat() {
      return k;
    },
    set fallbackFormat(s) {
      k = s, _.fallbackFormat = k;
    },
    get warnHtmlMessage() {
      return H;
    },
    set warnHtmlMessage(s) {
      H = s, _.warnHtmlMessage = s;
    },
    get escapeParameter() {
      return Y;
    },
    set escapeParameter(s) {
      Y = s, _.escapeParameter = s;
    },
    t: Fe,
    getLocaleMessage: Re,
    setLocaleMessage: yt,
    mergeLocaleMessage: Vt,
    getPostTranslationHandler: bt,
    setPostTranslationHandler: vt,
    getMissingHandler: pt,
    setMissingHandler: It,
    [at]: At
  };
  return I.datetimeFormats = Et, I.numberFormats = gt, I.rt = Tt, I.te = Ct, I.tm = St, I.d = Lt, I.n = Ot, I.getDateTimeFormat = Mt, I.setDateTimeFormat = Ut, I.mergeDateTimeFormat = Wt, I.getNumberFormat = $t, I.setNumberFormat = wt, I.mergeNumberFormat = xt, I[lt] = l, I[fe] = Rt, I[de] = Pt, I[Ee] = kt, process.env.NODE_ENV !== "production" && (I[w] = (s) => {
    _.__v_emitter = s;
  }, I[Z] = () => {
    _.__v_emitter = void 0;
  }), I;
}
const ot = "vue-i18n: composer properties", _e = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n DevTools",
  "vue-i18n-resource-inspector": "Vue I18n DevTools",
  "vue-i18n-timeline": "Vue I18n"
}, Rn = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, kn = {
  "vue-i18n-timeline": 16764185
};
let be;
function Pn(e, t) {
  return le(this, null, function* () {
    return new Promise((l, a) => {
      try {
        un({
          id: "vue-devtools-plugin-vue-i18n",
          label: _e["vue-devtools-plugin-vue-i18n"],
          packageName: "vue-i18n",
          homepage: "https://vue-i18n.intlify.dev",
          logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
          componentStateTypes: [ot],
          app: e
          // eslint-disable-line @typescript-eslint/no-explicit-any
        }, (n) => {
          be = n, n.on.visitComponentTree(({ componentInstance: r, treeNode: c }) => {
            An(r, c, t);
          }), n.on.inspectComponent(({ componentInstance: r, instanceData: c }) => {
            r.vnode.el && r.vnode.el.__VUE_I18N__ && c && (t.mode === "legacy" ? r.vnode.el.__VUE_I18N__ !== t.global.__composer && Ye(c, r.vnode.el.__VUE_I18N__) : Ye(c, r.vnode.el.__VUE_I18N__));
          }), n.addInspector({
            id: "vue-i18n-resource-inspector",
            label: _e["vue-i18n-resource-inspector"],
            icon: "language",
            treeFilterPlaceholder: Rn["vue-i18n-resource-inspector"]
          }), n.on.getInspectorTree((r) => {
            r.app === e && r.inspectorId === "vue-i18n-resource-inspector" && Vn(r, t);
          });
          const o = /* @__PURE__ */ new Map();
          n.on.getInspectorState((r) => le(this, null, function* () {
            if (r.app === e && r.inspectorId === "vue-i18n-resource-inspector")
              if (n.unhighlightElement(), Un(r, t), r.nodeId === "global") {
                if (!o.has(r.app)) {
                  const [c] = yield n.getComponentInstances(r.app);
                  o.set(r.app, c);
                }
                n.highlightElement(o.get(r.app));
              } else {
                const c = Mn(r.nodeId, t);
                c && n.highlightElement(c);
              }
          })), n.on.editInspectorState((r) => {
            r.app === e && r.inspectorId === "vue-i18n-resource-inspector" && $n(r, t);
          }), n.addTimelineLayer({
            id: "vue-i18n-timeline",
            label: _e["vue-i18n-timeline"],
            color: kn["vue-i18n-timeline"]
          }), l(!0);
        });
      } catch (n) {
        console.error(n), a(!1);
      }
    });
  });
}
function it(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function An(e, t, l) {
  const a = l.mode === "composition" ? l.global : l.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== a) {
    const n = {
      label: `i18n (${it(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(n);
  }
}
function Ye(e, t) {
  const l = ot;
  e.state.push({
    type: l,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: l,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: l,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: l,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: l,
    key: "messages",
    editable: !1,
    value: Le(t.messages.value)
  }), e.state.push({
    type: l,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: l,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function Le(e) {
  const t = {};
  return Object.keys(e).forEach((l) => {
    const a = e[l];
    $(a) && "source" in a ? t[l] = yn(a) : z(a) && a.loc && a.loc.source ? t[l] = a.loc.source : R(a) ? t[l] = Le(a) : t[l] = a;
  }), t;
}
const Cn = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function Dn(e) {
  return e.replace(/[<>"&]/g, Sn);
}
function Sn(e) {
  return Cn[e] || e;
}
function yn(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${Dn(e.source)}")` : "(?)"}`
    }
  };
}
function Vn(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const l = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [a, n] of t.__instances) {
    const o = t.mode === "composition" ? n : n.__composer;
    l !== o && e.rootNodes.push({
      id: o.id.toString(),
      label: `${it(a)} Scope`
    });
  }
}
function Mn(e, t) {
  let l = null;
  if (e !== "global") {
    for (const [a, n] of t.__instances.entries())
      if (n.id.toString() === e) {
        l = a;
        break;
      }
  }
  return l;
}
function ct(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const l = Array.from(t.__instances.values()).find((a) => a.id.toString() === e);
    return l ? t.mode === "composition" ? l : l.__composer : null;
  }
}
function Un(e, t) {
  const l = ct(e.nodeId, t);
  return l && (e.state = Wn(l)), null;
}
function Wn(e) {
  const t = {}, l = "Locale related info", a = [
    {
      type: l,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: l,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: l,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: l,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[l] = a;
  const n = "Locale messages info", o = [
    {
      type: n,
      key: "messages",
      editable: !1,
      value: Le(e.messages.value)
    }
  ];
  t[n] = o;
  {
    const r = "Datetime formats info", c = [
      {
        type: r,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[r] = c;
    const u = "Datetime formats info", m = [
      {
        type: u,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[u] = m;
  }
  return t;
}
function te(e, t) {
  if (be) {
    let l;
    t && "groupId" in t && (l = t.groupId, delete t.groupId), be.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: l,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function $n(e, t) {
  const l = ct(e.nodeId, t);
  if (l) {
    const [a] = e.path;
    a === "locale" && g(e.state.value) ? l.locale.value = e.state.value : a === "fallbackLocale" && (g(e.state.value) || P(e.state.value) || R(e.state.value)) ? l.fallbackLocale.value = e.state.value : a === "inheritLocale" && N(e.state.value) && (l.inheritLocale = e.state.value);
  }
}
function wn(e) {
  const t = g(e.locale) ? e.locale : Qe, l = g(e.fallbackLocale) || P(e.fallbackLocale) || O(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, a = $(e.missing) ? e.missing : void 0, n = N(e.silentTranslationWarn) || oe(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, o = N(e.silentFallbackWarn) || oe(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, r = N(e.fallbackRoot) ? e.fallbackRoot : !0, c = !!e.formatFallbackMessages, u = O(e.modifiers) ? e.modifiers : {}, m = e.pluralizationRules, E = $(e.postTranslation) ? e.postTranslation : void 0, L = g(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, f = !!e.escapeParameterHtml, p = N(e.sync) ? e.sync : !0;
  let T = e.messages;
  if (O(e.sharedMessages)) {
    const j = e.sharedMessages;
    T = Object.keys(j).reduce((_, ne) => {
      const ue = _[ne] || (_[ne] = {});
      return D(ue, j[ne]), _;
    }, T || {});
  }
  const { __i18n: k, __root: V, __injectWithOption: S } = e, F = e.datetimeFormats, H = e.numberFormats, Y = e.flatJson;
  return {
    locale: t,
    fallbackLocale: l,
    messages: T,
    flatJson: Y,
    datetimeFormats: F,
    numberFormats: H,
    missing: a,
    missingWarn: n,
    fallbackWarn: o,
    fallbackRoot: r,
    fallbackFormat: c,
    modifiers: u,
    pluralRules: m,
    postTranslation: E,
    warnHtmlMessage: L,
    escapeParameter: f,
    messageResolver: e.messageResolver,
    inheritLocale: p,
    __i18n: k,
    __root: V,
    __injectWithOption: S
  };
}
function ve(e = {}) {
  const t = Te(wn(e)), { __extender: l } = e, a = {
    // id
    id: t.id,
    // locale
    get locale() {
      return t.locale.value;
    },
    set locale(n) {
      t.locale.value = n;
    },
    // fallbackLocale
    get fallbackLocale() {
      return t.fallbackLocale.value;
    },
    set fallbackLocale(n) {
      t.fallbackLocale.value = n;
    },
    // messages
    get messages() {
      return t.messages.value;
    },
    // datetimeFormats
    get datetimeFormats() {
      return t.datetimeFormats.value;
    },
    // numberFormats
    get numberFormats() {
      return t.numberFormats.value;
    },
    // availableLocales
    get availableLocales() {
      return t.availableLocales;
    },
    // missing
    get missing() {
      return t.getMissingHandler();
    },
    set missing(n) {
      t.setMissingHandler(n);
    },
    // silentTranslationWarn
    get silentTranslationWarn() {
      return N(t.missingWarn) ? !t.missingWarn : t.missingWarn;
    },
    set silentTranslationWarn(n) {
      t.missingWarn = N(n) ? !n : n;
    },
    // silentFallbackWarn
    get silentFallbackWarn() {
      return N(t.fallbackWarn) ? !t.fallbackWarn : t.fallbackWarn;
    },
    set silentFallbackWarn(n) {
      t.fallbackWarn = N(n) ? !n : n;
    },
    // modifiers
    get modifiers() {
      return t.modifiers;
    },
    // formatFallbackMessages
    get formatFallbackMessages() {
      return t.fallbackFormat;
    },
    set formatFallbackMessages(n) {
      t.fallbackFormat = n;
    },
    // postTranslation
    get postTranslation() {
      return t.getPostTranslationHandler();
    },
    set postTranslation(n) {
      t.setPostTranslationHandler(n);
    },
    // sync
    get sync() {
      return t.inheritLocale;
    },
    set sync(n) {
      t.inheritLocale = n;
    },
    // warnInHtmlMessage
    get warnHtmlInMessage() {
      return t.warnHtmlMessage ? "warn" : "off";
    },
    set warnHtmlInMessage(n) {
      t.warnHtmlMessage = n !== "off";
    },
    // escapeParameterHtml
    get escapeParameterHtml() {
      return t.escapeParameter;
    },
    set escapeParameterHtml(n) {
      t.escapeParameter = n;
    },
    // pluralizationRules
    get pluralizationRules() {
      return t.pluralRules || {};
    },
    // for internal
    __composer: t,
    // t
    t(...n) {
      return Reflect.apply(t.t, t, [...n]);
    },
    // rt
    rt(...n) {
      return Reflect.apply(t.rt, t, [...n]);
    },
    // te
    te(n, o) {
      return t.te(n, o);
    },
    // tm
    tm(n) {
      return t.tm(n);
    },
    // getLocaleMessage
    getLocaleMessage(n) {
      return t.getLocaleMessage(n);
    },
    // setLocaleMessage
    setLocaleMessage(n, o) {
      t.setLocaleMessage(n, o);
    },
    // mergeLocaleMessage
    mergeLocaleMessage(n, o) {
      t.mergeLocaleMessage(n, o);
    },
    // d
    d(...n) {
      return Reflect.apply(t.d, t, [...n]);
    },
    // getDateTimeFormat
    getDateTimeFormat(n) {
      return t.getDateTimeFormat(n);
    },
    // setDateTimeFormat
    setDateTimeFormat(n, o) {
      t.setDateTimeFormat(n, o);
    },
    // mergeDateTimeFormat
    mergeDateTimeFormat(n, o) {
      t.mergeDateTimeFormat(n, o);
    },
    // n
    n(...n) {
      return Reflect.apply(t.n, t, [...n]);
    },
    // getNumberFormat
    getNumberFormat(n) {
      return t.getNumberFormat(n);
    },
    // setNumberFormat
    setNumberFormat(n, o) {
      t.setNumberFormat(n, o);
    },
    // mergeNumberFormat
    mergeNumberFormat(n, o) {
      t.mergeNumberFormat(n, o);
    }
  };
  return a.__extender = l, process.env.NODE_ENV !== "production" && (a.__enableEmitter = (n) => {
    const o = t;
    o[w] && o[w](n);
  }, a.__disableEmitter = () => {
    const n = t;
    n[Z] && n[Z]();
  }), a;
}
function xn(e, t, l) {
  return {
    beforeCreate() {
      const a = Q();
      if (!a)
        throw h(b.UNEXPECTED_ERROR);
      const n = this.$options;
      if (n.i18n) {
        const o = n.i18n;
        if (n.__i18n && (o.__i18n = n.__i18n), o.__root = t, this === this.$root)
          this.$i18n = je(e, o);
        else {
          o.__injectWithOption = !0, o.__extender = l.__vueI18nExtend, this.$i18n = ve(o);
          const r = this.$i18n;
          r.__extender && (r.__disposer = r.__extender(this.$i18n));
        }
      } else if (n.__i18n)
        if (this === this.$root)
          this.$i18n = je(e, n);
        else {
          this.$i18n = ve({
            __i18n: n.__i18n,
            __injectWithOption: !0,
            __extender: l.__vueI18nExtend,
            __root: t
          });
          const o = this.$i18n;
          o.__extender && (o.__disposer = o.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      n.__i18nGlobal && st(t, n, n), this.$t = (...o) => this.$i18n.t(...o), this.$rt = (...o) => this.$i18n.rt(...o), this.$te = (o, r) => this.$i18n.te(o, r), this.$d = (...o) => this.$i18n.d(...o), this.$n = (...o) => this.$i18n.n(...o), this.$tm = (o) => this.$i18n.tm(o), l.__setInstance(a, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const a = this.$i18n;
        this.$el.__VUE_I18N__ = a.__composer;
        const n = this.__v_emitter = pe();
        a.__enableEmitter && a.__enableEmitter(n), n.on("*", te);
      }
    },
    unmounted() {
      const a = Q();
      if (!a)
        throw h(b.UNEXPECTED_ERROR);
      const n = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", te), delete this.__v_emitter), this.$i18n && (n.__disableEmitter && n.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, n.__disposer && (n.__disposer(), delete n.__disposer, delete n.__extender), l.__deleteInstance(a), delete this.$i18n;
    }
  };
}
function je(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[at](t.pluralizationRules || e.pluralizationRules);
  const l = Ne(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(l).forEach((a) => e.mergeLocaleMessage(a, l[a])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((a) => e.mergeDateTimeFormat(a, t.datetimeFormats[a])), t.numberFormats && Object.keys(t.numberFormats).forEach((a) => e.mergeNumberFormat(a, t.numberFormats[a])), e;
}
const Oe = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Gn({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, n) => [
    ...a,
    // prettier-ignore
    ...n.type === nt ? n.children : [n]
  ], []) : t.reduce((l, a) => {
    const n = e[a];
    return n && (l[a] = n()), l;
  }, C());
}
function ut() {
  return nt;
}
const Hn = /* @__PURE__ */ Ie({
  /* eslint-disable */
  name: "i18n-t",
  props: D({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: (e) => q(e) || !isNaN(e)
    }
  }, Oe),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: l, attrs: a } = t, n = e.i18n || he({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const o = Object.keys(l).filter((L) => L[0] !== "_"), r = C();
      e.locale && (r.locale = e.locale), e.plural !== void 0 && (r.plural = g(e.plural) ? +e.plural : e.plural);
      const c = Gn(t, o), u = n[fe](e.keypath, c, r), m = D(C(), a), E = g(e.tag) || R(e.tag) ? e.tag : ut();
      return tt(E, m, u);
    };
  }
}), Be = Hn;
function Yn(e) {
  return P(e) && !g(e[0]);
}
function _t(e, t, l, a) {
  const { slots: n, attrs: o } = t;
  return () => {
    const r = { part: !0 };
    let c = C();
    e.locale && (r.locale = e.locale), g(e.format) ? r.key = e.format : R(e.format) && (g(e.format.key) && (r.key = e.format.key), c = Object.keys(e.format).reduce((f, p) => l.includes(p) ? D(C(), f, { [p]: e.format[p] }) : f, C()));
    const u = a(e.value, r, c);
    let m = [r.key];
    P(u) ? m = u.map((f, p) => {
      const T = n[f.type], k = T ? T({ [f.type]: f.value, index: p, parts: u }) : [f.value];
      return Yn(k) && (k[0].key = `${f.type}-${p}`), k;
    }) : g(u) && (m = [u]);
    const E = D(C(), o), L = g(e.tag) || R(e.tag) ? e.tag : ut();
    return tt(L, E, m);
  };
}
const jn = /* @__PURE__ */ Ie({
  /* eslint-disable */
  name: "i18n-n",
  props: D({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Oe),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const l = e.i18n || he({
      useScope: e.scope,
      __useComponent: !0
    });
    return _t(e, t, Jt, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      l[Ee](...a)
    ));
  }
}), Xe = jn;
function Bn(e, t) {
  const l = e;
  if (e.mode === "composition")
    return l.__getInstance(t) || e.global;
  {
    const a = l.__getInstance(t);
    return a != null ? a.__composer : e.global.__composer;
  }
}
function Xn(e) {
  const t = (r) => {
    process.env.NODE_ENV !== "production" && et(G(A.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE));
    const { instance: c, value: u } = r;
    if (!c || !c.$)
      throw h(b.UNEXPECTED_ERROR);
    const m = Bn(e, c.$), E = Je(u);
    return [
      Reflect.apply(m.t, m, [...Ke(E)]),
      m
    ];
  };
  return {
    created: (r, c) => {
      const [u, m] = t(c);
      ie && e.global === m && (r.__i18nWatcher = me(m.locale, () => {
        c.instance && c.instance.$forceUpdate();
      })), r.__composer = m, r.textContent = u;
    },
    unmounted: (r) => {
      ie && r.__i18nWatcher && (r.__i18nWatcher(), r.__i18nWatcher = void 0, delete r.__i18nWatcher), r.__composer && (r.__composer = void 0, delete r.__composer);
    },
    beforeUpdate: (r, { value: c }) => {
      if (r.__composer) {
        const u = r.__composer, m = Je(c);
        r.textContent = Reflect.apply(u.t, u, [
          ...Ke(m)
        ]);
      }
    },
    getSSRProps: (r) => {
      const [c] = t(r);
      return { textContent: c };
    }
  };
}
function Je(e) {
  if (g(e))
    return { path: e };
  if (O(e)) {
    if (!("path" in e))
      throw h(b.REQUIRED_VALUE, "path");
    return e;
  } else
    throw h(b.INVALID_VALUE);
}
function Ke(e) {
  const { path: t, locale: l, args: a, choice: n, plural: o } = e, r = {}, c = a || {};
  return g(l) && (r.locale = l), q(n) && (r.plural = n), q(o) && (r.plural = o), [t, c, r];
}
function Jn(e, t, ...l) {
  const a = O(l[0]) ? l[0] : {};
  (N(a.globalInstall) ? a.globalInstall : !0) && ([Be.name, "I18nT"].forEach((o) => e.component(o, Be)), [Xe.name, "I18nN"].forEach((o) => e.component(o, Xe)), [qe.name, "I18nD"].forEach((o) => e.component(o, qe))), e.directive("t", Xn(t));
}
const Kn = /* @__PURE__ */ y("global-vue-i18n");
function Ea(e = {}) {
  const t = __VUE_I18N_LEGACY_API__ && N(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__;
  process.env.NODE_ENV !== "production" && t && et(G(A.DEPRECATE_LEGACY_MODE));
  const l = N(e.globalInjection) ? e.globalInjection : !0, a = /* @__PURE__ */ new Map(), [n, o] = zn(e, t), r = /* @__PURE__ */ y(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  function c(f) {
    return a.get(f) || null;
  }
  function u(f, p) {
    a.set(f, p);
  }
  function m(f) {
    a.delete(f);
  }
  const E = {
    // mode
    get mode() {
      return __VUE_I18N_LEGACY_API__ && t ? "legacy" : "composition";
    },
    // install plugin
    install(f, ...p) {
      return le(this, null, function* () {
        if (process.env.NODE_ENV !== "production" && (f.__VUE_I18N__ = E), f.__VUE_I18N_SYMBOL__ = r, f.provide(f.__VUE_I18N_SYMBOL__, E), O(p[0])) {
          const V = p[0];
          E.__composerExtend = V.__composerExtend, E.__vueI18nExtend = V.__vueI18nExtend;
        }
        let T = null;
        !t && l && (T = la(f, E.global)), __VUE_I18N_FULL_INSTALL__ && Jn(f, E, ...p), __VUE_I18N_LEGACY_API__ && t && f.mixin(xn(o, o.__composer, E));
        const k = f.unmount;
        if (f.unmount = () => {
          T && T(), E.dispose(), k();
        }, process.env.NODE_ENV !== "production") {
          if (!(yield Pn(f, E)))
            throw h(b.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const S = pe();
          if (t) {
            const F = o;
            F.__enableEmitter && F.__enableEmitter(S);
          } else {
            const F = o;
            F[w] && F[w](S);
          }
          S.on("*", te);
        }
      });
    },
    // global accessor
    get global() {
      return o;
    },
    dispose() {
      n.stop();
    },
    // @internal
    __instances: a,
    // @internal
    __getInstance: c,
    // @internal
    __setInstance: u,
    // @internal
    __deleteInstance: m
  };
  return E;
}
function he(e = {}) {
  const t = Q();
  if (t == null)
    throw h(b.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw h(b.NOT_INSTALLED);
  const l = qn(t), a = Zn(l), n = rt(t), o = Qn(e, n);
  if (o === "global")
    return st(a, e, n), a;
  if (o === "parent") {
    let u = ea(l, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && se(G(A.NOT_FOUND_PARENT_SCOPE)), u = a), u;
  }
  const r = l;
  let c = r.__getInstance(t);
  if (c == null) {
    const u = D({}, e);
    "__i18n" in n && (u.__i18n = n.__i18n), a && (u.__root = a), c = Te(u), r.__composerExtend && (c[ge] = r.__composerExtend(c)), na(r, t, c), r.__setInstance(t, c);
  } else
    process.env.NODE_ENV !== "production" && o === "local" && se(G(A.DUPLICATE_USE_I18N_CALLING));
  return c;
}
function zn(e, t) {
  const l = _n(), a = __VUE_I18N_LEGACY_API__ && t ? l.run(() => ve(e)) : l.run(() => Te(e));
  if (a == null)
    throw h(b.UNEXPECTED_ERROR);
  return [l, a];
}
function qn(e) {
  const t = gn(e.isCE ? Kn : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw h(e.isCE ? b.NOT_INSTALLED_WITH_PROVIDE : b.UNEXPECTED_ERROR);
  return t;
}
function Qn(e, t) {
  return on(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Zn(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ea(e, t, l = !1) {
  let a = null;
  const n = t.root;
  let o = ta(t, l);
  for (; o != null; ) {
    const r = e;
    if (e.mode === "composition")
      a = r.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const c = r.__getInstance(o);
      c != null && (a = c.__composer, l && a && !a[lt] && (a = null));
    }
    if (a != null || n === o)
      break;
    o = o.parent;
  }
  return a;
}
function ta(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function na(e, t, l) {
  let a = null;
  bn(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = l, a = pe();
      const n = l;
      n[w] && n[w](a), a.on("*", te);
    }
  }, t), vn(() => {
    const n = l;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", te), n[Z] && n[Z](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const o = n[ge];
    o && (o(), delete n[ge]);
  }, t);
}
const aa = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], ze = ["t", "rt", "d", "n", "tm", "te"];
function la(e, t) {
  const l = /* @__PURE__ */ Object.create(null);
  return aa.forEach((n) => {
    const o = Object.getOwnPropertyDescriptor(t, n);
    if (!o)
      throw h(b.UNEXPECTED_ERROR);
    const r = mn(o.value) ? {
      get() {
        return o.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(c) {
        o.value.value = c;
      }
    } : {
      get() {
        return o.get && o.get();
      }
    };
    Object.defineProperty(l, n, r);
  }), e.config.globalProperties.$i18n = l, ze.forEach((n) => {
    const o = Object.getOwnPropertyDescriptor(t, n);
    if (!o || !o.value)
      throw h(b.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${n}`, o);
  }), () => {
    delete e.config.globalProperties.$i18n, ze.forEach((n) => {
      delete e.config.globalProperties[`$${n}`];
    });
  };
}
const ra = /* @__PURE__ */ Ie({
  /* eslint-disable */
  name: "i18n-d",
  props: D({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Oe),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const l = e.i18n || he({
      useScope: e.scope,
      __useComponent: !0
    });
    return _t(e, t, Kt, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      l[de](...a)
    ));
  }
}), qe = ra;
Tn();
Ht(zt);
Yt(qt);
jt(Ze);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = K();
  e.__INTLIFY__ = !0, Bt(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
export {
  qe as DatetimeFormat,
  Kn as I18nInjectionKey,
  Xe as NumberFormat,
  Be as Translation,
  Nn as VERSION,
  Ea as createI18n,
  he as useI18n,
  Xn as vTDirective
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vue-i18n@11.1.12_vue@3.5.18/~/vue-i18n/dist/vue-i18n.js
// module id = 1738
// module chunks = 41